import services from '../utils/services';
import client from '../utils/client';

export async function performSearchApi(params) {
  return client.get(services.search, { params });
}
